import { Controller } from "@hotwired/stimulus"

// Usage:
//   = button_tag "Add field",
//       data: {
//         controller: "callback",
//         callback_name_value: "addColumn",
//         action: "click->callback#invoke",
//       }
//
// With positional args (forwarded before the DOM event):
//   = link_to "Run action", "#",
//       data: {
//         controller: "callback",
//         callback_name_value: "legacyAction",
//         callback_args_value: ["argument"],
//         action: "click->callback#invoke",
//       }
export default class extends Controller {
  static values = {
    name: String,
    args: { type: Array, default: [] },
    passElement: { type: Boolean, default: false },
    eventFirst: { type: Boolean, default: false },
    preventDefault: { type: Boolean, default: false },
  }

  invoke(event) {
    if (this.preventDefaultValue) {
      event.preventDefault()
    }

    const fn = window[this.nameValue]
    if (typeof fn !== "function") {
      console.warn(`[callback] window.${this.nameValue} is not a function`, {
        element: this.element,
      })
      return
    }

    // Call shapes preserved from the original `onclick="..."` semantics:
    //
    //   onclick="fn()"              -> fn(...args, event)            // default
    //   onclick="fn(this)"          -> fn(element, ...args, event)   // pass_element
    //   onclick="fn(event, ...)"    -> fn(event, ...args)            // event_first
    //
    // The default puts the DOM event LAST so legacy handlers that ignore it
    // continue to ignore it.
    let callArgs
    if (this.eventFirstValue) {
      callArgs = [event, ...this.argsValue]
    } else if (this.passElementValue) {
      callArgs = [this.element, ...this.argsValue, event]
    } else {
      callArgs = [...this.argsValue, event]
    }

    try {
      fn.call(null, ...callArgs)
    } catch (err) {
      console.error(`[callback] window.${this.nameValue} threw`, err)
      throw err
    }
  }
}
